import { SOLANA_CLUSTER } from "./base";

export const getSolExplorerUrl = (address) => {
    return `https://explorer.solana.com/address/${address}?cluster=${SOLANA_CLUSTER}`;
};
